﻿/**
 * Numeric text input that inserts comma formatting.
 * This directive relies upon the autoNumeric jquery library
 * taken from https://github.com/BuffCoder/angular-currency/blob/master/angular-currency.js
 * (would have just used the package, but at the time, there were errors with the npm package)
**/
export class idiNumericInput implements angular.IDirective {
    public static factory(): angular.IDirectiveFactory {
        const directive: angular.IDirectiveFactory = () => new idiNumericInput();
        return directive;
    }

    public restrict = 'A';
    public require = '?ngModel';
    public scope = {
        idiNumericInput: '=',
        currencySymbol: '=',
        decimalPlaces: '='
    };

    public compile = (element: JQuery, attributes: any): void | angular.IDirectivePrePost => {
        const isInputText = element.is('input:text');


        return (scope: INumericInputScope, instanceElement: any, instanceAttributes: angular.IAttributes, controller: any) => {
            const updateElement = (newValue: any) => {
                if (!isNaN(parseFloat(newValue)) && isFinite(newValue)) {
                    instanceElement.autoNumeric('set', newValue);
                }
            };

            // see documentation for jquery autoNumeric for values for options
            const options = { aSign: scope.currencySymbol ? scope.currencySymbol : '', mDec: scope.decimalPlaces ? scope.decimalPlaces : 0 };

            instanceElement.autoNumeric('init', options);
            if (controller && isInputText) {
                scope.$watch(attributes.ngModel, () => { controller.$render(); });

                controller.$render = () => { updateElement(controller.$viewValue) };

                instanceElement.on('keyup', () => scope.$applyAsync(() => controller.$setViewValue(instanceElement.autoNumeric('get'))));
                instanceElement.on('change', () => scope.$applyAsync(() => controller.$setViewValue(instanceElement.autoNumeric('get'))));
            }
            else {
                if (isInputText) {
                    instanceAttributes.$observe('value', (value: any) => updateElement(value));
                }
            }
        };
    }
}

interface INumericInputScope extends angular.IScope {
    idiNumericInput: string;
    currencySymbol: string;
    decimalPlaces: string;
}